import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/header_logo.png'


const _hoisted_1 = { class: "shadow-lg text-white bg-infoColor border-b" }
const _hoisted_2 = { class: "mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-16" }
const _hoisted_4 = { class: "flex flex-wrap mt-3 sm:flex-col md:flex-row sm:my-3 sm:items-start md:items-center sm:space-x-0 md:space-x-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "",
    src: _imports_0,
    alt: "Logo"
  })
], -1)
const _hoisted_6 = { class: "flex flex-row space-x-5" }
const _hoisted_7 = { class: "hidden md:block" }
const _hoisted_8 = { class: "flex space-x-4 items-baseline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dayjsComponet = _resolveComponent("dayjsComponet")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_dayjsComponet),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ToggleButton, {
                    class: "p-button-sm bg-maskbg text-white border-0 shadow-none",
                    modelValue: _ctx.checkedLang,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedLang) = $event)),
                    onLabel: "English",
                    offLabel: "繁體中文",
                    onIcon: "pi pi-globe",
                    offIcon: "pi pi-globe",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeLang(_ctx.checkedLang)))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}